<template>
  <div class="page-plan">
    <a-spin v-if="!loaded">
      <div class="spin-placeholder"></div>
    </a-spin>
    <template v-else>
      <template v-if="!data.taskState">
        <a-result status="warning" title="提交的项目计划已被驳回" v-if="data.taskCheckResult == -1">
          <template #extra>
            <a-button icon="arrow-right" type="primary" @click="$router.push(`../plan/draft?id=${projectId}`)" v-if="hasPermission('project:other:plan:draft')">重新修订项目计划</a-button>
          </template>
        </a-result>
        <a-result status="warning" title="制订的项目计划暂存在草稿箱，未提交审核" v-else-if="tasks.length">
          <template #extra>
            <a-button icon="arrow-right" type="primary" @click="$router.push(`../plan/draft?id=${projectId}`)" v-if="hasPermission('project:other:plan:draft')">继续修订项目计划</a-button>
          </template>
        </a-result>
        <a-result status="warning" title="暂无项目计划，请尽快制订" v-else>
          <template #extra>
            <a-button icon="arrow-right" type="primary" @click="$router.push(`../plan/draft?id=${projectId}`)" v-if="hasPermission('project:other:plan:draft')">去制订项目计划</a-button>
          </template>
        </a-result>
      </template>
      <div class="panel-info-section" v-else-if="data.taskState == 1 || data.taskState == 2 || data.taskState == 9">
        <a-card class="v-mb-sm" v-if="data.taskState == 9">
          <a-spin :spinning="loading">
            <div class="stat-container">
              <div class="info-stat justify-around" style="height: 40px">
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" class="text-indigo">{{ statinfo.minDate }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">计划开始日期</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" class="text-indigo">{{ statinfo.maxDate }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">计划结束日期</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" class="text-indigo">{{ statinfo.period.toFixed(0) }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">计划周期（天）</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" ref="total" class="text-indigo">{{ statinfo.total.toFixed(0) }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">总任务</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" ref="completed" class="text-green">{{ statinfo.completed.toFixed(0) }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">已完成任务</div>
                </div>
                <div class="stat-item">
                  <div ref="noReply" class="stat-value text-primary">
                    <span style="font-size: 20px" ref="overdue">{{ statinfo.overdue.toFixed(0) }}</span>
                  </div>
                  <div class="stat-field ellipsis" style="font-size: 14px">逾期任务</div>
                </div>
              </div>
            </div>
          </a-spin>
        </a-card>
        <div class="panel-info-section-title">
          <a-icon type="caret-right" class="text-primary v-mr-xs" />
          <span class="text-bold">项目计划清单</span>
        </div>
        <div class="plan-list-actions flex items-center v-mb-sm">
          <a-space :size="4">
            <a-select size="small" :default-value="-1" v-model="filterForm.taskState" placeholder="任务状态" style="width: 100px" @change="handlePlanFilter">
              <a-select-option :value="-1">全部任务</a-select-option>
              <a-select-option :value="0">未开始</a-select-option>
              <a-select-option :value="1">进行中</a-select-option>
              <a-select-option :value="2">正常完成</a-select-option>
              <a-select-option :value="3">延期完成</a-select-option>
            </a-select>
            <a-select size="small" placeholder="是否逾期" allowClear v-model="filterForm.hasOverdate" style="width: 100px" @change="handlePlanFilter">
              <a-select-option :value="1">有逾期</a-select-option>
              <a-select-option :value="0">无逾期</a-select-option>
            </a-select>
            <a-input-search size="small" placeholder="任务名称" allowClear v-model="filterForm.taskName" style="width: 130px" @search="handlePlanFilter" />
          </a-space>
          <a-button size="small" type="danger" class="v-ml-auto" v-if="hasPermission('project:other:plan:delete') && data.taskState == 9" @click="handleRemove">
            <i class="fa fa-trash-o v-mr-sm"></i>
            删除
          </a-button>
        </div>
        <div class="relative-position">
          <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedKeys" :pagination="false" :data-source="visibleTasks" :scroll="{ x: '100%' }" :expand-icon-column-index="4">
            <a-table-column title="序号" data-index="index" :width="60" align="left">
              <template slot-scope="text, record">
                {{ record.no }}
              </template>
            </a-table-column>
            <a-table-column title="操作" data-index="action" :width="100" align="left">
              <template slot-scope="text, record" v-if="!record.isRoot">
                <span class="hover-line text-indigo" v-if="isProcessable(record.checkState)" @click="handleAcrhive(record)">处理</span>
                <span class="hover-line text-indigo" v-else-if="isSubmitable(record)" @click="handleAcrhive(record)">提交任务成果</span>
                <span class="hover-line text-indigo" v-else-if="record.checkState" @click="handleAcrhive(record)">查看</span>
              </template>
            </a-table-column>
            <a-table-column title="任务成果状态" data-index="checkState" :width="120" align="left">
              <template slot-scope="text, record" v-if="!record.isRoot">
                <span class="text-grey" v-if="!record.checkState">待提交</span>
                <span v-else-if="record.checkState == 9">已完成</span>
                <span class="text-red" v-else>待审核</span>
                <span class="text-red" v-if="record.checkResult == -1">(驳回)</span>
              </template>
            </a-table-column>
            <a-table-column title="任务状态" data-index="taskState" :width="80" align="left">
              <template slot-scope="text, record">
                <span class="text-grey" v-if="record.taskState == 0">未开始</span>
                <span class="text-red" v-else-if="record.taskState == 1">进行中</span>
                <span v-else-if="record.taskState == 2">已完成</span>
              </template>
            </a-table-column>
            <a-table-column title="任务名称" data-index="taskName" :ellipsis="true" :width="280" align="left">
              <template slot-scope="text, record">
                {{ record.taskName }}
              </template>
            </a-table-column>
            <a-table-column title="任务类型" data-index="taskType" :width="80" align="center">
              <template slot-scope="text, record">
                <template v-if="!record.isRoot">{{ record.taskType }}</template>
              </template>
            </a-table-column>
            <a-table-column title="任务周期" data-index="range" :width="190" align="center">
              <template slot-scope="text, record">
                <template>{{ record.startDate ? record.startDate + '~' + record.endDate : '-' }}</template>
              </template>
            </a-table-column>
            <a-table-column title="历时（天）" data-index="period" :width="90" align="center">
              <template slot-scope="text, record">
                <span v-if="record.startDate && record.endDate">{{ $utils.diffDays(record.startDate, record.endDate) }}d</span>
              </template>
            </a-table-column>
            <a-table-column title="责任人" data-index="owner" :ellipsis="true" :width="100">
              <template slot-scope="text, record">
                <span>{{ record.owner }}</span>
              </template>
            </a-table-column>
            <a-table-column title="逾期情况" data-index="isExpired" :width="120" align="left">
              <template slot-scope="text, record" v-if="!record.isRoot">
                <template v-if="record.taskState != 2">
                  <span class="text-red" v-if="record.restDays > 0">
                    逾期<b>{{ record.restDays }}</b>天
                  </span>
                  <span class="text-red" v-else-if="record.restDays == 0">明日逾期</span>
                  <span v-else-if="record.restDays < 0">
                    剩余<b class="text-indigo">{{ -record.restDays }}</b>天
                  </span>
                </template>
                <template v-else>
                  <span class="text-red" v-if="record.restDays > 0">
                    逾期<b>{{ record.restDays }}</b>天完成
                  </span>
                  <span v-else-if="record.restDays == 0">按计划完成</span>
                  <span v-else-if="record.restDays < 0">
                    提前<b class="text-indigo">{{ -record.restDays }}</b>天完成
                  </span>
                </template>
              </template>
            </a-table-column>
            <a-table-column title="项目文件" data-index="files" :width="230" align="left">
              <template slot-scope="text, record">
                <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="projectId"></file-container>
              </template>
            </a-table-column>
            <a-table-column title="备注" data-index="remark" :width="200" :ellipsis="true">
              <template slot-scope="text, record">
                <template v-if="!record.isRoot">{{ record.remark }}</template>
              </template>
            </a-table-column>
            <a-table-column title="对应费用明细" data-index="budget" :width="300" align="left">
              <template slot-scope="text, record">
                <div class="relative-position" v-if="!record.isRoot">
                  <ul class="cell-list" v-if="record.budgets && record.budgets.length">
                    <li v-for="item in record.budgets" :key="item.budgetId">
                      <a-badge color="#f24a78" />
                      {{ item.pname }} — {{ item.name }} / {{ $utils.thousands(item.amount) }} 元
                    </li>
                  </ul>
                </div>
              </template>
            </a-table-column>
          </a-table>
          <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0" v-if="data.taskState != 9">
            <div class="fit flex items-center justify-center" style="background: rgba(255, 255, 255, 0.5)">
              <a-result status="warning">
                <template #title>
                  <div class="text-red">
                    <i class="fa fa-hourglass-2 fa-pulse-2 v-mr-md"></i>
                    项目计划正在等待审核...
                  </div>
                </template>
                <template #icon></template>
                <template #extra v-if="isProcessable(data.taskState)">
                  <a-button class="v-px-sm" icon="arrow-right" type="primary" @click="$router.push(`../plan/review?id=${projectId}`)">立即去审核</a-button>
                </template>
              </a-result>
            </div>
          </div>
        </div>
      </div>
    </template>
    <task v-model="showTask" :task="task" @submit="handleTaskSubmit" />
  </div>
</template>

<script>
import Task from '@/views/project/common/task'
import { viewPrj } from '@/api/project/other'
import { getTasks, delTasks } from '@/api/project/common'
import { convertTasksToTableData } from '@/utils/data'
import gsap from 'gsap'
export default {
  name: 'ProjectPlan',
  components: {
    Task,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      loading: false,
      loaded: false,
      expandedKeys: [],
      tasks: [],
      data: {},
      filterForm: {
        taskState: -1,
        hasOverdate: undefined,
        taskName: '',
      },
      statinfo: {
        minDate: undefined,
        maxDate: undefined,
        period: 0,
        completed: 0,
        total: 0,
        overdue: 0,
      },
      visibleTasks: [],
      showTask: false,
      task: {},
    }
  },
  watch: {
    $route() {
      this.projectId = +this.$route.query.id
    },
    projectId() {
      this.load()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      viewPrj(this.projectId).then(({ data }) => {
        if (data.success) {
          this.data = data.result
        }
        this.loaded = true
        this.loadTasks()
      })
    },
    loadTasks() {
      this.loading = true
      getTasks(this.projectId).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let completed = 0
          let overdue = 0
          let minDate = undefined
          let maxDate = undefined
          let total = 0
          let { $moment } = this
          let nowTimes = $moment().format('YYYY-MM-DD')
          result.forEach(item => {
            if (item.taskPid != 0) {
              let { taskState, startDate, endDate, isExpired, actualEndDate, submitTime } = item
              
              total++
              if (taskState === 2) {
                completed++
              }
              if (isExpired) {
                overdue++
              }
              if (startDate && (!minDate || $moment(startDate).valueOf() < $moment(minDate).valueOf())) {
                minDate = startDate
              }
              if (endDate && (!maxDate || $moment(endDate).valueOf() > $moment(maxDate).valueOf())) {
                maxDate = endDate
              }
              if (endDate) {
                if (taskState == 2) {
                  // 任务已完成，如果指定实际结束日期，逾期天数=实际结束日期-计划结束日期，未指定实际结束日期则逾期天数=任务提交日期-计划结束日期
                  if (actualEndDate) {
                    console.log(this.$utils.diffDays(endDate, actualEndDate))
                    item.restDays = this.$utils.diffDays(endDate, actualEndDate) - 1
                  } else if (submitTime) {
                    item.restDays = this.$utils.diffDays(endDate, submitTime.substring(0, 10)) - 1
                  }
                } else {
                  // 任务未完成，逾期天数=当前日期-计划结束日期
                  item.restDays = this.$utils.diffDays(endDate, nowTimes) - 1
                }
              }
            }
          })
          this.statinfo.minDate = minDate
          this.statinfo.maxDate = maxDate
          gsap.to(this.statinfo, 0.5, {
            completed,
            overdue,
            total,
            period: minDate && maxDate ? this.$utils.diffDays(minDate, maxDate) : 0,
          })
          let records = convertTasksToTableData(result)
          this.tasks = records
          this.onPlanFilter(-1)
        }
      })
      this.loading = false
    },
    isSubmitable(record) {
      let { checkState, ownerType, ownerId, creator } = record
      if (checkState || ownerType != 1) {
        // 审核中不能提交
        return false
      }
      let { id: userId, userName, superAdmin } = this.userinfo
      if (superAdmin) {
        // 系统管理员可提交
        return true
      }
      if (ownerId && ownerId == userId) {
        // 指定责任人可提交
        return true
      }
      if (!ownerId && creator == userName) {
        // 未指定责任人，计划填报者可提交
        return true
      }
      return false
    },
    handlePlanFilter() {
      let { taskState, hasOverdate, taskName } = this.filterForm
      let tasks = this.$utils.cloneDeep(this.tasks)
      console.log('handlePlanFilter', taskState, hasOverdate, taskName)
      if (taskState !== -1) {
        if (taskState === 2) {
          tasks = tasks
            .filter(task => task.children && task.children.some(d => d.taskState == 2 && d.isExpired === 0))
            .map(task => ({
              ...task,
              children: task.children ? task.children.filter(d => d.taskState == 2 && d.isExpired === 0) : undefined,
            }))
        } else if (taskState === 3) {
          tasks = tasks
            .filter(task => task.children && task.children.some(d => d.taskState == 2 && (d.isExpired === 1 || d.restDays > 0)))
            .map(task => ({
              ...task,
              children: task.children ? task.children.filter(d => d.taskState == 2 && (d.isExpired === 1 || d.restDays > 0)) : undefined,
            }))
        } else {
          tasks = tasks
            .filter(task => task.children && task.children.some(d => d.taskState == taskState))
            .map(task => ({
              ...task,
              children: task.children ? task.children.filter(d => d.taskState == taskState) : undefined,
            }))
        }
      }
      if (hasOverdate !== void 0) {
        tasks = tasks
          .filter(task => task.children && task.children.some(d => d.isExpired == hasOverdate))
          .map(task => ({
            ...task,
            children: task.children ? task.children.filter(d => d.isExpired == hasOverdate) : undefined,
          }))
      }
      if (taskName.trim() !== '') {
        tasks = tasks
          .filter(p => (p.taskName && p.taskName.indexOf(taskName) > -1) || (p.children && p.children.some(d => d.taskName.indexOf(taskName) > -1)))
          .map(task => ({
            ...task,
            children: task.children && task.children.some(d => d.taskName.indexOf(taskName) > -1) ? task.children.filter(d => d.taskName.indexOf(taskName) > -1) : undefined,
          }))
      }
      this.visibleTasks = tasks
      this.expandedKeys = this.visibleTasks.filter(d => d.children && d.children.length).map(d => d.uid)
    },
    onPlanFilter(value) {
      if (value === -1) {
        this.visibleTasks = this.tasks.map(task => Object.assign({}, task))
      } else {
        this.visibleTasks = this.tasks.filter(task => task.children && task.children.some(d => d.taskState == value))
      }
      this.expandedKeys = this.visibleTasks.filter(d => d.children && d.children.length).map(d => d.uid)
    },
    handleAcrhive(task) {
      this.task = task
      this.showTask = true
    },
    handleTaskSubmit() {
      this.showTask = false
      this.loadTasks()
    },
    handleRemove() {
      let { projectId } = this
      this.$confirm({
        title: '确认删除项目计划？',
        okText: '确认删除',
        centered: true,
        content: h => (
          <div>
            <div>删除项目计划后，以下数据会同步删除：</div>
            <div class="text-red v-my-xs">1）项目计划所有任务成果数据</div>
            <div class="text-red v-my-xs">2）项目计划变更记录</div>
          </div>
        ),
        onOk: () => {
          // 异步关闭
          this.$message.destroy()
          return new Promise((resolve, reject) => {
            delTasks(projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.load()
                this.$root.$emit('reloadPrj')
                resolve()
              } else {
                this.$message.warn(data.msg)
                reject()
              }
            })
          })
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
